// extracted by mini-css-extract-plugin
export default {"backdrop":"reader_backdrop__ZXfa4","foreground":"reader_foreground__Se5X+","coating":"reader_coating__HAKf3"};